import { Link } from 'react-router-dom'

/** Port of pages/Error404.vue */
export function NotFound() {
  return (
    <div className="error-page">
      <div>
        <div className="error-code">404</div>
        <div className="error-text">Oops. Nothing here...</div>
        <div className="cta-row center">
          <Link className="cta next" to="/">
            Go Home
          </Link>
        </div>
      </div>
    </div>
  )
}
